import Vue from "vue"
import Router from 'vue-router'
import Home from '@/pages/Home'

// BDW
import MonitoringBdw from "@/pages/BDoubleWin/MonitoringBdw"
import ValidationFh from "@/pages/BDoubleWin/ValidationFh"
import RechercheFdes from "@/pages/BDoubleWin/RechercheFdes"

// TICKETING
import Tickets from "@/pages/GestionProjet/Tickets"
import TicketDetail from "@/pages/GestionProjet/TicketDetail"
import TicketDemande from "@/pages/GestionProjet/TicketDemande"
import FicheLivraison from "@/pages/GestionProjet/FicheLivraison"

// MME
import Leads from "@/pages/MME/Leads"

// FRS
import AppointmentForm from "@/pages/Fournisseur/AppointmentForm";
import NewsletterFrs from "@/pages/Fournisseur/Newsletter";

// ADMIN
import Mfa from "@/pages/Securite/Mfa"
import ProcDyn from "@/pages/Admin/ProcDyn"
import MaterielInformatiqueListe from "@/pages/Admin/MaterielInformatiqueListe"

import AdminRights from "@/pages/Admin/AdminRights"
import AdminUsers from "@/pages/Admin/AdminUsers"
import AutoImport from "@/pages/Admin/AutoImport"

import GenerateNewsletterCharts from "@/pages/Adherent/Newsletter/GenerateCharts";

// ACHAT
import ReportingTickets from "@/pages/GestionProjet/ReportingTickets"
import DeclarationHR from "@/pages/Achat/DeclarationHR"
import FrsHR from "@/pages/Achat/FrsHR"
import CaVente from "@/pages/Achat/CaVente"
import TopFrsPrevisionnel from "@/pages/Achat/TopFrsPrevisionnel"
import TopFrsPrevisionnelSupplier from "@/pages/Achat/TopFrsPrevisionnelSupplier"

import FrsCampaign from "@/pages/Achat/FrsCampaign"
import FicheFrs from '@/pages/Achat/FicheFrs'
import DashboardCDM from "@/pages/Achat/DashboardCdm/DashboardCDM"
import Contrats from "@/pages/Achat/DashboardCdm/Contrats"
import RFA from "@/pages/Achat/DashboardCdm/RFA"
import DashboardCDMHome from "@/pages/Achat/DashboardCdm/Home"
import RecapFournisseur from "@/pages/Achat/DashboardCdm/RecapFournisseur"

// ADHERENT
import CmsCreate from "@/pages/Adherent/CmsCreate"
import CmsGestion from "@/pages/Adherent/CmsGestion"
import CmsRead from "@/pages/Adherent/CmsRead"
import CmsReadSingle from "@/pages/Adherent/CmsReadSingle"
import CmsCateg from "@/pages/Adherent/CmsCateg"
import Newsletter from "@/pages/Adherent/Newsletter/Newsletter";

// RFA
import GenerateFolderRfa from "@/pages/RFA/GenerateFolderRfa"
import GenerateRfaDeclarationTab from "@/pages/RFA/GenerateRfaDeclarationTab"
import AlerteTxRfa from "@/pages/RFA/AlerteTxRfa"
import GenerateRfaSourceFile from "@/pages/RFA/GenerateRfaSourceFile.vue";

// DASHBOARD GRFA
import DashboardGRFA from "@/pages/RFA/DashboardGRFA/DashboardGRFA.vue";
import DashboardGRFAHome from "@/pages/RFA/DashboardGRFA/Home.vue";

import DashboardGRFADetails from "@/pages/RFA/DashboardGRFA/Details/Details.vue";
import DashboardGRFADetailsSuiviRFA from "@/pages/RFA/DashboardGRFA/Details/SuiviRfa.vue"
import DashboardGRFADetailsSuiviContrats from "@/pages/RFA/DashboardGRFA/Details/SuiviContrats.vue"

// Admin Maps
import AdminMaps from "@/pages/Admin/AdminMaps/Admin";
import AdminMapsAdherents from "@/pages/Admin/AdminMaps/Adherents";
import AdminMapsTrancheCa from "@/pages/Admin/AdminMaps/TrancheCa";
import AdminMapsFiltres from "@/pages/Admin/AdminMaps/Filtres";
import AdminMapsParameters from "@/pages/Admin/AdminMaps/Parameters";
import AdminMapsMapsParameters from "@/pages/Admin/AdminMaps/MapsParameters";
import SimulationFacturation from "@/pages/Achat/SimulationFacturation";
import GenerationMotDePasse from "@/pages/Admin/GenerationMotDePasse";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: "Page d'accueil - CMEM TK",
        baseUrl: "",
        groupName: "Accueil",
      }
    },
    {
      path: "/fiche-frs",
      name: "FicheFrs",
      component: FicheFrs,
      meta: {
        title: "Fiche RDV Fournisseurs",
        baseUrl: "fiche-frs",
        groupName: "Adhérents",
      }
    },
    {
      path: "/previsionnel-top-frs",
      name: "TopFrsPrevisionnel",
      component: TopFrsPrevisionnel,
      meta: {
        title: "TOP 50 Prévisionnel",
        baseUrl: "previsionnel-top-frs",
        groupName: "Adhérents",
      }
    },
    {
      path: "/previsionnel-top-frs-supplier",
      name: "TopFrsPrevisionnelSupplier",
      component: TopFrsPrevisionnelSupplier,
      meta: {
        title: "TOP 50 Prévisionnel - TOP Fournisseur",
        baseUrl: "previsionnel-top-frs",
        groupName: "Adhérents",
      }
    },
    {
      path: "/monitoring-bdw",
      name: "MonitoringBdw",
      component: MonitoringBdw,
      meta: {
        title: "BDW - Monitoring",
        baseUrl: "monitoring-bdw",
        groupName: "BDoubleWin",
      }
    },
    {
      path: "/validate-fh",
      name: "ValidationFh",
      component: ValidationFh,
      meta: {
        title: "Validation FH",
        baseUrl: "validate-fh",
        groupName: "BDoubleWin",
      }
    },
    {
      path: "/recherche-fdes",
      name: "RechercheFdes",
      component: RechercheFdes,
      meta: {
        title: "Recherche FDES",
        baseUrl: "recherche-fdes",
        groupName: "BDoubleWin",
      }
    },
    {
      path: "/admin-droits",
      name: "AdminRights",
      component: AdminRights,
      meta: {
        title: "Admin Modules",
        baseUrl: "admin-droits",
        groupName: "Admin",
      }
    },
    {
      path: "/admin-users",
      name: "AdminUsers",
      component: AdminUsers,
      meta: {
        title: "Admin Utilisateurs",
        baseUrl: "admin-users",
        groupName: "Admin",
      }
    },
    {
      path: "/tickets",
      name: "Tickets",
      component: Tickets,
      meta: {
        title: "Gestion des tickets",
        baseUrl: "tickets",
        groupName: "Gestion Projet",
      },
    },
    {
      path: "/tickets/detail",
      name: "TicketDetail",
      component: TicketDetail,
      meta: {
        title: "Detail d'un ticket",
        baseUrl: "tickets", // baseUrl est un hack qui permet de passer le droit d'un module sur une page liée frérot
        groupName: "Gestion Projet",
      }
    },
    {
      path: "/ticket-demande",
      name: "TicketDemande",
      component: TicketDemande,
      meta: {
        title: "Création demande",
        baseUrl: "ticket-demande",
        groupName: "Gestion Projet",
      },
    },
    {
      path: "/tickets-suivi",
      name: "ReportingTickets",
      component: ReportingTickets,
      meta: {
        title: "Reporting tickets",
        baseUrl: "tickets-suivi",
        groupName: "Gestion Projet",
      },
    },
    {
      path: "/frs-campaign",
      name: "FrsCampaign",
      component: FrsCampaign,
      meta: {
        title: "Fournisseurs campagnes",
        baseUrl: "frs-campaign",
        groupName: "Achat",
      }
    },
    {
      path: "/declaration-hr",
      name: "DeclarationHR",
      component: DeclarationHR,
      meta: {
        title: "Déclarations Hors Référencement",
        baseUrl: "declaration-hr",
        groupName: "Adhérents",
      }
    },
    {
      path: "/frs-hr",
      name: "FrsHR",
      component: FrsHR,
      meta: {
        title: "Fournisseurs Hors Référencement",
        baseUrl: "frs-hr",
        groupName: "Adhérents",
      }
    },
    {
      path: "/ca-vente",
      name: "CaVente",
      component: CaVente,
      meta: {
        title: "Déclaration CA Vente",
        baseUrl: "ca-vente",
        groupName: "Adhérents",
      }
    },
    {
      path: "/materiel-informatique",
      name: "MaterielInformatiqueListe",
      component: MaterielInformatiqueListe,
      meta: {
        title: "Matériel Informatique",
        baseUrl: "materiel-informatique",
        groupName: "Admin",
      }
    },
    {
      path: "/mfa",
      name: "Mfa",
      component: Mfa,
      meta: {
        title: "Double Authentification",
        baseUrl: "mfa",
        groupName: "Sécurité",
      }
    },
    {
      path: "/leads",
      name: "Leads",
      component: Leads,
      meta: {
        title: "Gestion des Leads MME",
        mme: true,
        baseUrl: "leads",
        groupName: "MME",
      },
    },
    {
      path: "/fiche-livraison",
      name: "FicheLivraison",
      component: FicheLivraison,
      meta: {
        title: "Génération des fiches de livraison via Trello",
        baseUrl: "fiche-livraison",
        groupName: "Gestion Projet",
      }
    },
    {
      path: "/appointment-form",
      name: "Données fiche RDV Fournisseur",
      component: AppointmentForm,
      meta: {
        title: "Gestion données Fiche RDV frs",
        baseUrl: "appointment-form",
        groupName: "Fournisseur",
      }
    },
    {
      path: "/newsletter-frs",
      name: "Newsletter Fournisseur",
      component: NewsletterFrs,
      meta: {
        title: "Newsletter Fournisseur",
        baseUrl: "newsletter-frs",
        groupName: "Fournisseur",
      }
    },
    {
      path: "/procdyn",
      name: "Procédures dynamiques",
      component: ProcDyn,
      meta: {
        title: "Procédures dynamiques",
        baseUrl: "procdyn",
        groupName: "Admin",
      }
    },
    {
      path: "/auto-import",
      name: "AutoImport",
      component: AutoImport,
      meta: {
        title: "Import Automatique",
        baseUrl: "auto-import",
        groupName: "Admin",
      }
    },
    {
      path: "/dashboard-cdm",
      component: DashboardCDM,
      meta: {
        title: "Dashboard Chef de Marché",
        baseUrl: "dashboard-cdm",
        groupName: "Achat",
        hideNavbar: true,
        hideFooter: true,
        appNoMargin: true
      },
      children: [
        {
          path: "",
          name: "home",
          component: DashboardCDMHome,
          meta: {
            title: "Accueil",
            icon: "home",
            baseUrl: "dashboard-cdm",
            groupName: "Achat",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "rdv",
          name: "rdv",
          component: RecapFournisseur,
          meta: {
            title: "RDV",
            icon: "bullseye",
            baseUrl: "dashboard-cdm",
            groupName: "Achat",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        // {
        //   path: "contrats",
        //   name: "contrats",
        //   component: Contrats,
        //   meta: {
        //     title: "Contrats",
        //     icon: "file-contract",
        //     baseUrl: "dashboard-cdm",
        //     groupName: "Achat",
        //   },
        // },
        // {
        //   path: "rfa",
        //   name: "rfa",
        //   component: RFA,
        //   meta: {
        //     title: "RFA",
        //     icon: "money-bill",
        //     baseUrl: "dashboard-cdm",
        //     groupName: "Achat",
        //   },
        // },
      ]
    },
    {
      path: "/dashboard-grfa",
      component: DashboardGRFA,
      meta: {
        title: "Dashboard GRFA",
        baseUrl: "dashboard-grfa",
        groupName: "RFA",
        hideNavbar: true,
        hideFooter: true,
        appNoMargin: true
      },
      children: [
        {
          path: "",
          name: "home",
          component: DashboardGRFAHome,
          meta: {
            title: "Accueil",
            icon: "home",
            baseUrl: "dashboard-grfa",
            groupName: "RFA",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "rdv",
          name: "rdv",
          component: RecapFournisseur,
          meta: {
            title: "RDV",
            icon: "bullseye",
            baseUrl: "dashboard-grfa",
            groupName: "RFA",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "details",
          name: "details",
          component: DashboardGRFADetails,
          meta: {
            title: "Détails",
            icon: "database",
            baseUrl: "dashboard-grfa",
            groupName: "RFA",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
          children: [
            {
              path: "",
              component: DashboardGRFADetailsSuiviRFA,
              meta: {
                title: "Suivi RFA",
                baseUrl: "dashboard-grfa",
                groupName: "RFA",
                hideNavbar: true,
                hideFooter: true,
                appNoMargin: true
              },
            } ,
            {
              path: "suivi-rfa",
              component: DashboardGRFADetailsSuiviRFA,
              meta: {
                title: "Suivi RFA",
                baseUrl: "dashboard-grfa",
                groupName: "RFA",
                hideNavbar: true,
                hideFooter: true,
                appNoMargin: true
              },
            },
            {
              path: "/suivi-contrats",
              component: DashboardGRFADetailsSuiviContrats,
              meta: {
                title: "Suivi Contrats",
                baseUrl: "dashboard-grfa",
                groupName: "RFA",
                hideNavbar: true,
                hideFooter: true,
                appNoMargin: true
              },
            }
        ]
        }
      ]
    },
    {
      path: "/cms-create",
      name: "CmsCreate",
      component: CmsCreate,
      meta: {
        title: "Création de contenu - CMS",
        baseUrl: "cms-create",
        groupName: "Adherent",
      }
    },
    {
      path: "/cms-gestion",
      name: "CmsGestion",
      component: CmsGestion,
      meta: {
        title: "Gestion de contenu - CMS",
        baseUrl: "cms-gestion",
        groupName: "Adherent",
      }
    },
    {
      path: "/cms-read",
      name: "CmsRead",
      component: CmsRead,
      meta: {
        title: "Visualisation de contenu - CMS",
        baseUrl: "cms-read",
        groupName: "Adherent",
      }
    },
    {
      path: "/article/:id",
      name: "CmsReadSingle",
      component: CmsReadSingle,
      meta: {
        title: "Visualisation de contenu - CMS",
        baseUrl: "cms-read",
        groupName: "Adherent",
      }
    },
    {
      path: "/cms-categ",
      name: "CmsCateg",
      component: CmsCateg,
      meta: {
        title: "Gestion de contenu - CMS - Catégories",
        baseUrl: "cms-categ",
        groupName: "Adherent",
      }
    },
    {
      path: "/admin-maps",
      component: AdminMaps,
      meta: {
        title: "Administration Maps",
        baseUrl: "admin-maps",
        groupName: "Admin",
        hideNavbar: true,
        hideFooter: true,
        appNoMargin: true
      },
      children: [
        {
          path: "adherents",
          name: "adherents",
          component: AdminMapsAdherents,
          meta: {
            title: "Adherents",
            icon: "child",
            baseUrl: "admin-maps",
            groupName: "Admin",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "maps",
          name: "maps",
          component: AdminMapsMapsParameters,
          meta: {
            title: "Paramètres carto",
            icon: "globe-europe",
            baseUrl: "admin-maps",
            groupName: "Admin",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "tranches-ca",
          name: "tranches-ca",
          component: AdminMapsTrancheCa,
          meta: {
            title: "Tranches CA",
            icon: "euro-sign",
            baseUrl: "admin-maps",
            groupName: "Admin",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "filtres",
          name: "filtres",
          component: AdminMapsFiltres,
          meta: {
            title: "Filtres",
            icon: "filter",
            baseUrl: "admin-maps",
            groupName: "Admin",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
        {
          path: "parametres",
          name: "parametres",
          component: AdminMapsParameters,
          meta: {
            title: "Paramètres",
            icon: "cog",
            baseUrl: "admin-maps",
            groupName: "Admin",
            hideNavbar: true,
            hideFooter: true,
            appNoMargin: true
          },
        },
      ]
    },
    {
      path: "/rfa-generate",
      name: "GenerateFolderRfa",
      component: GenerateFolderRfa,
      meta: {
        title: "Génération Dossier RFA",
        baseUrl: "rfa-generate",
        groupName: "RFA",
      }
    },
    {
      path: "/rfa-generate-tab",
      name: "GenerateRfaDeclarationTab",
      component: GenerateRfaDeclarationTab,
      meta: {
        title: "Génération Table de déclaration RFA",
        baseUrl: "rfa-generate-tab",
        groupName: "RFA",
      }
    },
    {
      path: "/alerte-tx-rfa",
      name: "AlerteTxRfa",
      component: AlerteTxRfa,
      meta: {
        title: "Suivi Alerte Tx RFA",
        baseUrl: "alerte-tx-rfa",
        groupName: "RFA",
      }
    },
    {
      path: "/generation-fichier-source",
      name: "GenerateRfaSourceFile",
      component: GenerateRfaSourceFile,
      meta: {
        title: "Generation Fichier Source",
        baseUrl: "generation-fichier-source",
        groupName: "RFA",
      }},
    {
      path: "/newsletter",
      name: "Newsletter",
      component: Newsletter,
      meta: {
        title: "Newsletter",
        baseUrl: "newsletter",
        groupName: "Adherent",
      }
    },
    {
      path: "/newsletter-charts",
      name: "GenerateNewsletterCharts",
      component: GenerateNewsletterCharts,
      meta: {
        title: "Newsletter",
        baseUrl: "newsletter",
        groupName: "Adherent",
      }
    },
    {
      path: "/simulation-facturation",
      name: "SimulationFacturation",
      component: SimulationFacturation,
      meta: {
        title: "Simulation Facturation BDW",
        baseUrl: "simulation-facturation",
        groupName: "Achat",
      }
    },
    {
      path: "/generation-mot-de-passe",
      name: "GenerationMotDePasse",
      component: GenerationMotDePasse,
      meta: {
        title: "Génération de mot de passe",
        baseUrl: "generation-mot-de-passe",
        groupName: "Admin",
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js